import { useState, useRef, useEffect } from "react";
import "./test.css"
import { Button } from "@mui/material";
import { AudioRecorder,useAudioRecorder  } from 'react-audio-voice-recorder';
import axios from "axios";

const mimeType = "audio/webm";

const App = () => {
    let [recordOption, setRecordOption] = useState(false);
    const toggleRecordOption = () => {
            setRecordOption(!recordOption);
        
    };

    const [audioFile, setAudioFile] = useState(null);
    let recorderControls = useAudioRecorder()
    const {
        startRecording,
        stopRecording,
        togglePauseResume,
        recordingBlob,
        isRecording,
        isPaused,
        recordingTime,
        mediaRecorder
      } = useAudioRecorder();
    
    useEffect(() => {
        if (recorderControls?.recordingBlob) {
            const url = URL.createObjectURL(recorderControls.recordingBlob);
            console.log(url);
          setAudioFile(url);
        }
      }, [recorderControls.recordingBlob]);

    const addAudioElement = (blob) => {
        const url = URL.createObjectURL(blob);
        const audio = document.createElement("audio");
        audio.src = url;
        audio.controls = true;
        document.body.appendChild(audio);
        setAudioFile(url);
      };

      const stopRecordingAndSend = () => {
        recorderControls.stopRecording();
      
        setTimeout(()=>{

            console.log("audioFile:", audioFile);
        },2000)
      };
    

    
    return (
        <div className="record-body">
            <h1>React Media Recorder</h1>
            <div className="Button-flex">
    
                <Button onClick={toggleRecordOption}>
                  Record Audio
                </Button>
            </div>
            <div>
                {recordOption && <AudioRecorders/>}
            </div>
            <div>

            <AudioRecorder 
                audioTrackConstraints={{
                noiseSuppression: true,
                echoCancellation: true,
                }} 
                showVisualizer={true}
                
                recorderControls={recorderControls}
                downloadFileExtension="webm"
            />
      <button onClick={stopRecordingAndSend}>Stop recording</button>
            <button onClick={recorderControls.startRecording}>start recording</button>

            </div>
        </div>
    );
};
export default App;

const AudioRecorders = () => {
    const [stream, setStream] = useState(null);
    const mediaRecorder = useRef(null);
    const [recordingStatus, setRecordingStatus] = useState("inactive");
    const [audioChunks, setAudioChunks] = useState([]);
    const [audio, setAudio] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [duration, setDuration] = useState(0);
  
    const startRecording = async () => {

       if ("MediaRecorder" in window) {
            try {
              const streamData = await navigator.mediaDevices.getUserMedia({
                audio: true,
              });
              setStream(streamData);
              setRecordingStatus("recording");
              setStartTime(new Date());
             // const streamData = await navigator.mediaDevices.getUserMedia({
               // audio: true,
              //});
              ///setStream(streamData);
              const mimeType = "audio/webm";
              const media = new MediaRecorder(streamData, { type: mimeType });
              mediaRecorder.current = media;
              const localAudioChunks = [];
          
              mediaRecorder.current.ondataavailable = (event) => {
                if (typeof event.data === "undefined") return;
                if (event.data.size === 0) return;
                localAudioChunks.push(event.data);
              };
          
              mediaRecorder.current.start();
              setAudioChunks(localAudioChunks);


            } catch (err) {
              alert(err.message);
            }
          } else {
            alert("The MediaRecorder API is not supported in your browser.");
          }
     
    };
  
    const stopRecording = async () => {
      setRecordingStatus("inactive");
      setEndTime(new Date());
  
      mediaRecorder.current.stop();
  
      mediaRecorder.current.onstop = () => {
        const audioBlob = new Blob(audioChunks, { type: "audio/webm" });
        const audioUrl = URL.createObjectURL(audioBlob);
        setAudio(audioUrl);
        setAudioChunks([]);
      
      };
      stream.getTracks().forEach((track) => track.stop());
    };
    useEffect(() => {
        let intervalId;
    
        if (recordingStatus === "recording") {
          intervalId = setInterval(() => {
            const currentTime = new Date().getTime();
            setDuration(currentTime - startTime);
          }, 100);
        } else {
          clearInterval(intervalId);
        }
    
        return () => {
          clearInterval(intervalId);
        };
      }, [recordingStatus, startTime]);
    
      const formatTime = (time) => {
        const minutes = Math.floor(time / 60000);
        const seconds = Math.floor((time / 1000) % 60);
    
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
      };

      console.log(audio);
      const sendAudioFile = async () => {
        if (audio) {
          const audioBlob = await fetch(audio).then((response) => response.blob());
          const file = new File([audioBlob], "recording.webm", { type: audioBlob.type });
          const formData = new FormData();
          console.log(file);
          formData.append("audio", file);
       
          // Now you can send the formData to your server using axios or any other HTTP library
          // const response = await axios.post('YOUR_SERVER_URL', formData);
          // console.log('File upload successful:', response);
          // Add any additional logic or state updates after successful upload
        }
      };
    return (
      <div>
        <h2>Audio Recorder</h2>
        <main>
          <div className="audio-controls">
        
            {recordingStatus === "inactive" ? (
              <Button onClick={startRecording} type="Button">
                Start Recording
              </Button>
            ) : null}
            {recordingStatus === "recording" ? (
              <Button onClick={stopRecording} type="Button">
                Stop Recording
              </Button>
            ) : null}
          </div>
          <div>
            {audio ? (
              <div className="audio-container">
                <audio src={audio} controls></audio>
              </div>
            ) : null}
          </div>
          <Button onClick={sendAudioFile}>Send</Button>
          <div>
            {startTime ? (
                <div>
                <p>Recording duration: {formatTime(duration)}</p>
                </div>
            ) : null}
            </div>
        </main>
      </div>
    );
  };

